<template>
    <div class="animate fadeIn">
        <component-new-header
            title="Workflow Events Triggers"
            :isLoading="events.loading"
            @reload-data="getMappings()"
            :hasCreate="true"
            :hasback="false"
            :hasDropdown="false"
            :has-search="false"
            @create-press="openManage"
            createButtonText="Create Mappings"
        >
        </component-new-header>
        <b-card class="card-wrap" border-variant="info">
            <b-table
                :items="mappings.data"
                :fields="mappingsColumns"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="mappings.loading"
                :hover="true"
                :dark="false"
                :striped="false"
                :bordered="false"
                :small="false"
                :fixed="false"
            >
                <template slot="cell(action)" slot-scope="data">
                    <div class="">
                        <b-button
                            size="sm"
                            class="button-circle mr-2"
                            variant="primary"
                            @click="openManage(data.item)"
                        >
                            <i class="fa fa-pencil"></i>
                        </b-button>

                        <b-button
                            size="sm"
                            class="button-circle mr-2"
                            variant="danger"
                            @click="deleteMappings(data.item)"
                        >
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
        </b-card>
        <manage-events
            v-if="manage.open"
            :open="manage.open"
            :mapping="manage.mappings"
            :events="events.data"
            :workflows="workflows"
            @close="closeManage"
        ></manage-events>
    </div>
</template>

<script>
import ComponentNewHeader from "@/components/componentNewHeader/index.vue";
import gql from "graphql-tag";
import {
    deleteMappings,
    getEvents,
    getMappings,
} from "@/services/eventWorkflows";
import ManageEvents from "@/views/workflows/events/components/manage.vue";

export default {
    components: { ManageEvents, ComponentNewHeader },
    data() {
        return {
            loading: false,
            workflows: [],
            currentPage: 1,
            perPage: 10,
            totalWorkflows: 0,
            mappingsColumns: [
                {
                    key: "eventId.name",
                    label: "Name",
                },
                {
                    key: "eventId.description",
                    label: "description",
                },
                {
                    key: "workflowId",
                    label: "Workflows",
                },
                {
                    key: "action",
                    label: "Action",
                },
            ],
            mappings: {
                data: [],
                loading: false,
            },
            events: {
                data: [],
                loading: false,
            },
            manage: {
                open: false,
                mappings: {},
            },
        };
    },
    methods: {
        async getMappings() {
            try {
                const { success, data } = await getMappings();
                this.mappings.data = data;
            } catch (e) {}
        },
        async getEvents() {
            try {
                const { success, data } = await getEvents();
                this.events.data = data;
            } catch (e) {}
        },
        async deleteMappings(mappings) {
            deleteMappings(mappings._id)
                .then(() => {
                    this.$toasted.success("Mappings deleted successfully");
                })
                .catch((err) => {
                    this.$toasted.error("Failed to delete mappings");
                })
                .finally(() => {
                    this.getMappings();
                });
        },
        openManage(mappings) {
            if (mappings) {
                this.manage.mappings = {
                    _id: mappings._id,
                    eventId: mappings.eventId._id,
                    workflowId: mappings.workflowId,
                };
            }
            this.manage.open = true;
        },
        closeManage() {
            this.manage.open = false;
            this.manage.mappings = {};
            this.getMappings();
        },
    },
    mounted() {
        this.getMappings();
        this.getEvents();
    },
    apollo: {
        workflows: {
            query: gql`
                query getWorkflowList {
                    getWorkflowList {
                        name
                        version
                        description
                        ownerEmail
                        timeoutSeconds
                        createdBy
                        updatedBy
                        createTime
                        updateTime
                        historyId
                        readOnly
                    }
                }
            `,
            update: (data) => data.getWorkflowList || [],
            result({ data }) {
                this.totalWorkflows = (data.getWorkflowList || []).length;
            },
        },
    },
};
</script>

<style lang="scss" scoped></style>
